<template>
  <v-container grid-list-md>
    <v-layout
      row
      sticky-container
    >
      <v-flex
        md12
        class="card-container"
      >
        <material-card>
          <div
            class="d-flex"
            style="align-items:center"
          >
            <Fieldset style="width:300px" />
            <BlackBtn
              class="ml-3"
              @click="onDownload"
            >
              <v-icon
                left
              >
                mdi-printer
              </v-icon>
              印刷する
            </BlackBtn>
          </div>
        </material-card>
      </v-flex>
    </v-layout>
    <v-layout
      row
      sticky-container
    >
      <v-flex md12>
        <v-card>
          <table
            class="v-table v-data-table theme--light"
            md8
          >
            <thead>
              <tr>
                <th>
                  &nbsp;
                </th>
                <th
                  v-for="h in headers"
                  :key="h.value"
                >
                  {{ h.text }}
                </th>
              </tr>
            </thead>

            <transition-group
              name="flip-list"
              tag="tbody"
            >
              <tr
                v-for="(c, i) in selectedCustomers"
                :key="c.id"
                class="draggable-item"
                draggable="true"
                @dragstart.self.stop="drag(c.id, i)"
                @drop.prevent="draggedItem = null"
                @dragover.prevent
                @dragenter="dragEnter(i)"
              >
                <th>
                    &nbsp;
                </th>
                <template
                  v-for="h in headers"
                >
                  <td
                    v-if="h.value === 'tank'"
                    :key="h.value"
                  >
                    <div>
                      <td>
                        <v-icon
                          v-if="c.serialNo != null"
                          color="blue"
                        >
                          mdi mdi-flash-circle
                        </v-icon>
                      </td>
                      <td
                        :class="{ 'multi-tanks': c.tanks.length > 1 }"
                      >
                        <span
                          v-if="c.tanks.length > 1"
                        >
                          +{{ c.tanks.length - 1 }}
                        </span>
                      </td>
                    </div>
                  </td>
                  <td
                    v-else
                    :key="h.value"
                    :class="[h.cssClass, h.type === 'number' ? 'text-xs-right' : '', h.type === 'colored' ? 'pl-1 pr-1' : '']"
                  >
                    <div
                      v-if="h.type === 'colored'"
                      :style="c[h.value].style"
                    >
                      {{ c[h.value].label }}
                    </div>
                    <template v-else>
                      {{ c[h.value] }}
                    </template>
                  </td>
                </template>
              </tr>
            </transition-group>
          </table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { api } from '@/api'
import { download } from './download'
import { Fieldset } from './components/DeliveryCondition/index'
import { BlackBtn } from '@/components/ui'

export default {
  components: {
    Fieldset,
    BlackBtn
  },
  data: function () {
    return {
      draggedItem: null
    }
  },
  computed: {
    ...mapState('list', ['area', 'headers', 'selectedIDs']),
    ...mapGetters('list', ['areaName', 'selectedCustomers'])
  },
  methods: {
    ...mapMutations('list', ['deSelectID', 'selectID']),
    drag (id, index) {
      this.draggedItem = {
        index,
        id
      }
    },
    dragEnter (index) {
      this.deSelectID(this.draggedItem.index)
      this.draggedItem.index = index
      this.selectID({ index, id: this.draggedItem.id })
    },
    async onDownload () {
      const customers = this.selectedIDs
      /* apiはバイナリで返している。swagger-codegen はresponse_and_data.data
       * を固定して返すバグが存在している。このバグを回避するため、downloadDeliveryListWithHttpInfo 使用している。 */
      const { response } = await api.downloadDeliveryListWithHttpInfo({ customers }, this.area)
      const fileName = `${this.areaName}_${new Date().toLocaleDateString().split('/').join('')}`
      download(response.body, `${fileName}.xlsx`)
    }
  }
}
</script>

<style lang=scss scoped>
.draggable-item {
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
}
.flip-list-move {
  transition: transform 80ms;
}
.buttons {
  margin: 15px;
}
.card-container{
  display: flex;
  justify-content: flex-end;
}
</style>
